import { Eye, EyeOff } from "@untitledui/icons";
import { type ComponentProps, useState } from "react";
import { Input } from "@/components/base/input/input";

type PasswordInputProps = Omit<ComponentProps<typeof Input>, "type" | "trailingAction">;

export const PasswordInput = (props: PasswordInputProps) => {
  const [visible, setVisible] = useState(false);
  const Icon = visible ? EyeOff : Eye;

  return (
    <Input
      {...props}
      type={visible ? "text" : "password"}
      trailingAction={
        <button
          type="button"
          tabIndex={-1}
          aria-label={visible ? "Hide password" : "Show password"}
          aria-pressed={visible}
          disabled={props.isDisabled}
          onClick={() => setVisible((shown) => !shown)}
          className="mr-3 inline-flex shrink-0 cursor-pointer text-fg-quaternary transition-colors hover:text-fg-quaternary_hover disabled:cursor-not-allowed"
        >
          <Icon className="size-4" aria-hidden />
        </button>
      }
    />
  );
};
